import App from './AppReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({App})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js